import Vue from 'vue'
/**
 * 定义全局 自定义指令
 */
Vue.directive('dialogDrag', {
  inserted(el) {
    const header = el.querySelector('.el-dialog__header')
    const _dialog = el.querySelector('.el-dialog')
    // 初始化样式
    header.style.cursor = 'move'     // 鼠标更换为 小手图标
    header.style.userSelect = 'none'    // 禁止选择内容
    _dialog.style.transform = 'translate(0px, 0px)'
  },
  componentUpdated(el) {
    // 查询DOM 和 transform
    const _dialog = el.querySelector('.el-dialog')
    const _transform = _dialog.style.getPropertyValue('transform')
    const _matrix = new DOMMatrix(_transform)
    // 恢复原位置
    if (_matrix.m41 != 0 || _matrix.m42 != 0)
      _dialog.style.transform = 'translate(0px, 0px)'
  },
  bind(el) {
    // 查询DOM 和 transform
    const _dialog = el.querySelector('.el-dialog')
    const _header = el.querySelector('.el-dialog__header')
    // 初始化
    let _pos = {
      left: 0,
      top: 0,
      x: 0,
      y: 0
    }
    // 设置移动样式
    _header.style.cursor = 'move'
    // 鼠标移动事件的回调函数
    const mousemoveCallback = (e) => {
      // 计算位置
      let dx = e.clientX - _pos.x + _pos.left
      let dy = e.clientY - _pos.y + _pos.top
      // 限定左侧位置
      if (dx <= -_pos.limitX) {
        dx = -_pos.limitX
      }
      // 限定右侧位置 
      else if (dx >= _pos.limitX) {
        dx = _pos.limitX
      }
      // 限定顶部位置 
      if (dy <= -_dialog.offsetTop) {
        dy = -_dialog.offsetTop
      }
      // 限定底部位置 
      else if (dy >= _pos.limitY) {
        dy = _pos.limitY
      }
      // 设置 位置
      _dialog.style.transform = `translate(${dx}px, ${dy}px)`
    }
    // 放开鼠标 事件的回调函数
    const mouseupCallback = () => {
      document.removeEventListener('mousemove', mousemoveCallback)
      document.removeEventListener('mouseup', mouseupCallback)
    }
 
    // 定义绑定事件
    _header.addEventListener('mousedown', (e) => {
      // 获取transform
      const _transform = _dialog.style.getPropertyValue('transform')
      const _matrix = new DOMMatrix(_transform)
      // 计算边缘
      const limitX = (el.offsetWidth - _dialog.offsetWidth) / 2
      const limitY = el.offsetHeight - _dialog.offsetTop - _dialog.offsetHeight
      // 初始位置 
      _pos = {
        left: _matrix.m41,
        top: _matrix.m42,
        x: e.clientX,
        y: e.clientY,
        limitX: Math.abs(limitX),
        limitY: Math.abs(limitY)
      }
      // 添加事件
      document.addEventListener('mousemove', mousemoveCallback) // 移动事件
      document.addEventListener('mouseup', mouseupCallback) // 放开事件
    })
    // mousedown end
  }
})